import {
  CREATE_PERMISSION_FAIL,
  CREATE_PERMISSION_REQUEST,
  CREATE_PERMISSION_SUCCESS,
  SHOW_PERMISSION_FAIL,
  SHOW_PERMISSION_REQUEST,
  SHOW_PERMISSION_SUCCESS,
} from "../../ActionType/BranchType/PermissionType";

export const createPermissionReducer = (
  state = { loading: true, storePermissions: [], error: "" },
  action
) => {
  switch (action.type) {
    case CREATE_PERMISSION_REQUEST:
      return {
        loading: true,
        storePermissions: action.payload,
      };
    case CREATE_PERMISSION_SUCCESS:
      return {
        loading: false,
        storePermissions: action.payload,
        error: "",
      };
    case CREATE_PERMISSION_FAIL:
      return {
        loading: false,
        storePermissions: action.payload,
        error: "",
      };
    default:
      return state;
  }
};


export const showPermissionReducer = (
    state = { loading: true, permissions: [], error: "" },
    action
  ) => {
    switch (action.type) {
      case SHOW_PERMISSION_REQUEST:
        return {
          loading: true,
          permissions: action.payload,
        };
      case SHOW_PERMISSION_SUCCESS:
        return {
          loading: false,
          permissions: action.payload,
          error: "",
        };
      case SHOW_PERMISSION_FAIL:
        return {
          loading: false,
          permissions: action.payload,
          error: "",
        };
      default:
        return state;
    }
  };